import React from 'react';
import { IconProps } from './IconTypes';

const DeepCenterLogo: React.FC<IconProps> = ({ 
  size = 16, 
  color = "currentColor",
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size}
      viewBox="0 0 148.6 109.4" 
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M62.1,107.8c-3.7-1.5-7-3.5-9.7-6.2c-1.7-1.8-3.6-2.4-5.9-2.7c-9-1.5-17.8-3.8-25.7-8.5C11.5,85,4.4,77.7,1,67.4
        c-0.8-2.3-1.3-4.7-1-7.2c0.6-4.6,3.7-7.2,7.6-9c5.4-2.5,11.3-3.4,17.2-3.6c9.2-0.3,18.2,1.4,27,3.8c0.9,0.3,1.9,0.5,2.8,0.7
        c0.2-0.5-0.1-0.6-0.3-0.8c-4.3-4-5.9-9.2-6.6-14.8c-0.7-6.2-0.1-12.2,2.3-18c0.2-0.5,0.2-0.9-0.1-1.3c0-0.1-0.1-0.2-0.1-0.2
        c-0.7-2.4-2-4.2-4.4-5.2c-0.3-0.1-0.5-0.3-0.7-0.5c-1.3-1-1.3-1.9,0.2-2.7c1.1-0.6,2.3-1,3.6-1.3c1-0.2,1.6-0.6,2.2-1.5
        c2.8-4.6,7.5-6.5,12.9-5.4c5.1,1.1,8.3,4.6,9.1,10c0.1,0.5,0.3,1,0.2,1.5c-0.4,3.2,0.8,5.9,2.2,8.7c2.3,4.7,3.2,9.8,3.8,14.9
        c0.6,5,0.7,10,2.5,14.8c0.9,2.4,2.2,4.5,4.2,6.3c0.6,0.5,1.2,1,0.8,1.9c-0.3,0.8-1.2,0.9-1.9,0.9c-2.4,0-4.7,0.1-7.1-0.2
        c6.9,2.9,14,5.1,21.6,4.5c5.1-0.4,9.9-1.8,14-4.9c0.4-0.3,0.8-0.7,1.1-1c2.4-2.6,2.6-4.3,0.5-7.2c-1.5-2.1-2.9-4.1-3.7-6.6
        c-1.3-4.1-0.5-7.9,1.2-11.7c0.2-0.6,0.7-0.9,1.3-0.8c0.6,0.1,0.9,0.5,1,1c0.3,1.2,0.6,2.3,1.3,3.4c0.9,1.4,2,2.5,3.6,3.1
        c3.2,1.2,6.2,2.8,7.6,6.4c3.3-2.2,6.9-2,10.4-1.6c0.9,0.1,1.9,0,2.8-0.1c2.3-0.3,4.3-1.2,6.1-2.6c0.6-0.5,1.3-1,2-0.4
        c0.7,0.6,0.5,1.4,0.2,2.1c-2,5.9-6.1,9.9-11.8,12.2c-2,0.8-4.1,1.3-6.2,1.8c-4.1,0.9-6.9,3.3-8.6,7.1c-3.2,7.4-7.9,13.9-13.7,19.5
        c-8.5,8.1-18.6,13.2-30,15.7c-3.6,0.8-7.3,1.3-11,1.5c-0.4,0-0.7,0.1-1.2,0.2c0.1,1.7,0.8,3.1,1.4,4.5c0.4,0.8,0.8,1.6,1.2,2.4
        c0.3,0.5,0.3,1.1-0.1,1.6c-0.4,0.5-0.9,0.5-1.5,0.4C65.3,108.9,63.8,108.4,62.1,107.8 M52.2,45c3.6,6.2,13.2,11.5,20.6,11.3
        c-3.3-2.1-5.8-4.8-7.8-8.1c-0.6-1.1-1.2-2.1-0.2-3.3c0.4-0.4,0.5-1.2,0.5-1.9c0.4-3.5,1.4-6.9,3.1-10c0.2-0.4,0.6-0.9-0.3-1.4
        c-1,1.5-1.7,3.2-2.3,4.9c-0.8,2.1-1.1,4.3-1.4,6.6c-0.1,0.9-0.2,2-1.3,2.3c-1.1,0.4-1.7-0.4-2.4-1.2c-1.3-1.5-2-3.3-2.4-5.2
        c-0.9-3.9-0.7-7.8,0.3-11.5c1-3.6-1.5-7.1-4.6-8.1c-2-0.6-2.2-0.7-2.8,1.4C48.7,28.9,48.8,36.9,52.2,45 M9.5,78.3
        C14.3,84,20.2,88.1,26.9,91c6.6,2.9,13.6,4.7,21.1,5.8c-0.8-1.3-1.4-2.1-1.8-3c-0.6-1.3-1.6-1.9-3-2.2c-4.6-1.1-9-2.6-13.3-4.5
        C18,81.8,8.5,74,2.7,62.2c-0.1-0.2-0.1-0.7-0.7-0.7C2.6,67.9,5.4,73.3,9.5,78.3 M13.5,73.6c8.4,8.2,18.5,13.1,29.9,15.8
        c0.1-2.2-0.6-3.3-2.3-3.8c-9.3-2.9-17.6-7.5-24.8-14.1c-2.6-2.4-5.8-3.9-8.6-6c-0.1-0.1-0.2,0-0.5,0.1C8.9,68.6,11,71.1,13.5,73.6
         M53.9,17.1c1.8,0.4,3.3,1.3,4.8,2.6c0.8-2.2,2.2-3.7,3.4-5.3c1.3-1.7,1.7-3.6,1.2-5.6c-0.6-2.5-2.4-4.1-4.9-4.4
        C56.1,4.1,52.9,5.9,52,8c-0.2,0.5-0.2,0.9,0.1,1.3c0.5,1,0.2,1.8-0.4,2.6c-0.4,0.4-0.8,0.8-0.9,1.4C50.7,14.8,52.1,16.6,53.9,17.1
         M79,94.4c-2,0.2-3.9,0.4-5.9,0.5c-2.4,0.1-4.8,0.1-7.1,0c-1,0-1.3,0.4-1.2,1.3c0.2,1.8,0.4,2,2.2,1.9c3.9-0.3,7.8-0.7,11.6-1.6
        c1.5-0.4,3.1-0.6,4.6-1.4C81.8,94.5,80.6,94.2,79,94.4 M30.4,78.9c3.5,1.8,7.2,3.4,11,4.5c0.2-1-0.2-1.3-0.8-1.5
        c-1.8-0.6-3.5-1.3-5.2-2c-3.2-1.3-6.4-2.7-9.6-4C27.1,77,28.6,78,30.4,78.9 M64.5,89.6c-0.3,0-0.7,0-0.8,0.4
        c-0.3,0.9,0.8,2.7,1.7,2.7c2.1,0.1,4.3,0,6.4,0c0.3,0,0.7,0,0.8-0.6C70.1,91.3,67.4,90.5,64.5,89.6 M39.2,71.7
        c-0.6-1.5-1.6-2.1-2.7-1.6c-0.8,0.4-1.4,1.1-1.2,2.2c0.2,1,0.9,1.7,2,1.6C38.5,73.8,39.2,73.1,39.2,71.7 M55.8,54.6
        c-0.4,0.3-0.8,0.4-0.8,1.2c2.1,0.3,4.3,0,6.4-0.1C59.6,55.1,58.2,53,55.8,54.6 M49.8,10.4c-0.3-1.3-1-1.4-2.6-0.2
        C48.1,10.6,48.7,11.8,49.8,10.4z" />
      <path d="M58.2,9.5c-0.4,1-1,1.4-2,1c-0.8-0.4-0.9-1-0.6-1.8c0.2-0.6,0.7-0.9,1.3-0.8C57.8,8,58.2,8.6,58.2,9.5z" />
    </svg>
  );
};

export default DeepCenterLogo;